<template>
  <SlideSidebarContainer>
    <template #title>
      <span>notificações</span>
    </template>

    <NotificationList :user="user" />
  </SlideSidebarContainer>
</template>

<script>
  import { mapGetters } from 'vuex'
  import NotificationList from '@/components/notification/NotificationList'
  import SlideSidebarContainer from '@/components/layout/sidebars/SlideSidebarContainer'

  export default {
    components: {
      SlideSidebarContainer,
      NotificationList,
    },

    computed: {
      ...mapGetters('user', ['user'])
    }
  }
</script>